import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-zbewegungsart-list-view',
  imports: [],
  templateUrl: './zbewegungsart.list-view.html',
  styleUrls: ['./zbewegungsart.list-view.css'],
})
export class ZbewegungsartListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
